import { useIntl } from 'react-intl';

import { freightFormMessages } from './freight-form-messages';
import { Dropdown } from '../../../common/Dropdown';

import type { ShipFromOption } from '../../freight-browser-types';

type ShipFromSectionProps = {
  value: string;
  onChange: (id: string) => void;
  options: ShipFromOption[];
};

export const ShipFromSection = ({ value, onChange, options }: ShipFromSectionProps) => {
  const intl = useIntl();

  const selectData = options.map((opt) => ({ value: opt.id, label: opt.name }));

  const handleChange = (val: string | null) => {
    if (val) onChange(val);
  };

  return (
    <Dropdown
      data={selectData}
      label={intl.formatMessage(freightFormMessages.shipFromLabel)}
      onChange={handleChange}
      placeholder={intl.formatMessage(freightFormMessages.shipFromPlaceholder)}
      value={value || null}
    />
  );
};
